import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcHelp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.953 8.466q.41.374.41.991 0 .417-.238.769-.236.351-.97.998-.573.518-.818.984a2.2 2.2 0 0 0-.244 1.027q0 .33.237.553a.8.8 0 0 0 .567.223q.33 0 .568-.23a1 1 0 0 0 .294-.575q.057-.359.244-.639t.719-.783q.732-.704 1.005-1.22Q15 10.045 15 9.4q0-1.279-.87-2.069-.868-.79-2.262-.79a3.214 3.214 0 0 0-2.73 1.45.8.8 0 0 0-.135.518.68.68 0 0 0 .222.46.82.82 0 0 0 .683.208.86.86 0 0 0 .625-.38q.243-.345.581-.525t.754-.18q.675 0 1.085.374M11.057 17.12q.337.338.811.338t.812-.337.338-.812-.338-.811a1.1 1.1 0 0 0-.812-.338q-.474 0-.811.338a1.1 1.1 0 0 0-.338.811q0 .474.338.812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }));
}
var IcHelp = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHelp));

export { IcHelp as I };
